import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RefreshCartService} from '../checkout/services/refresh-cart.service';
import {OccEndpointsService} from '@spartacus/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable()
export class RefreshCartInterceptor implements HttpInterceptor {
  constructor(
    private refreshCartService: RefreshCartService,
    private occEndpoints: OccEndpointsService,
    @Inject(PLATFORM_ID) public platformId: string
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (isPlatformBrowser(this.platformId) && this.isCartsApiEndpoint(request.url) && this.shouldAddParameter()) {
      request = request.clone({
        setParams: {
          refreshCart: 'true',
        },
      });
      this.refreshCartService.hasBeenRefreshed();
    }
    return next.handle(request);
  }

  private shouldAddParameter() {
    return this.refreshCartService.shouldRefreshCart();
  }

  private isCartsApiEndpoint(url: string): boolean {
    const CARTS_ENDPOINT_REGEX = new RegExp(`${this.occEndpoints.getBaseUrl()}/users/(.*)/carts(/[^/]+)?$`);
    return CARTS_ENDPOINT_REGEX.test(this.removeRequestParameters(url));
  }

  private removeRequestParameters(url: string): string {
    return url.indexOf('?') === -1 ? url : url.substring(0, url.indexOf('?'));
  }
}
